<script>/**
 * @overview 主页面 - 菜单
 */

import baseUrl from '../../utils/api';
import router from '../Statistical/router';

export default {
  name: 'MainMenu',
  inject: ['reload'],
  data() {
    return {
      menus: [],
      show: true,
      isAgent: false,
    };
  },
  computed: {
    children() {
      return this.menus.flatMap(item => item.children);
    },

    defaultActive() {
      const { path } = this.$route;
      const pattern = /(\/\w+)/;

      const match = (pattern.exec(path) || [])[0];
      const target = this.children.find(({ index }) => index.startsWith(match));

      return target ? target.index : match;
    },
    school() {
      return this.$store.state.choicesSchool;
    },
    user() {
      return this.$store.state.mainUser;
    },
    schoolUser() {
      return this.$store.state.user;
    },
  },
  watch: {
    user(val) {
      this.show = false;
      this.$nextTick(() => {
        this.setMenus();
        this.show = true;
      });
    },
  },
  created() {
    this.isAgent = this.schoolUser.as_agent;
    this.setMenus();
    const arr = [];
    // 校区管理跳转第一个菜单
    this.children.forEach((item) => {
      if (this.$permissions(item.permission)) {
        arr.push(item);
      }
    });
    const target = arr[0];
    if (this.$route.query.showFull) {
      this.$router.replace(target.index);
    }
  },
  methods: {
    setMenus() {
      const menus = [
        {
          name: '校区管理',
          icon: 'el-icon-s-home',
          permission: 'school_admin',
          children: [
            // {
            //   name: '参数设置',
            //   permission: 'curriculum_center.course',
            //   index: '/department-config',
            // },
            {
              name: '员工管理',
              permission: 'school_admin_staff',
              index: '/staff-list',
            },
            {
              name: '分校管理',
              permission: 'school_admin_branch',
              index: '/branchSchool',
              showRole: this.checkRoleType(),
            },
          ],
        },
        // {
        //   name: '计费中心',
        //   icon: 'el-icon-s-finance',
        //   permission: 'school_billing',
        //   children: [
        //     {
        //       name: '账户管理',
        //       permission: 'school_billing_account',
        //       index: '/account',
        //     },
        //     {
        //       name: '账户流水',
        //       permission: 'school_billing_waterlist',
        //       index: '/waterlist',
        //     },
        //     {
        //       name: '校区账单',
        //       permission: 'school_billing_bill',
        //       index: '/bill',
        //     },
        //   ],
        // },
        {
          name: '课程统计',
          icon: 'el-icon-s-goods',
          permission: 'course_statistics',
          children: [
            {
              name: '授权统计',
              permission: 'course_statistics.authority',
              index: '/AuthorityStatistics',
            },
            {
              name: '耗课情况',
              permission: 'course_statistics.consump',
              index: '/ConsumpSituation',
            },
          ],
        },
        // {
        //   name: '商品中心',
        //   icon: 'el-icon-s-goods',
        //   permission: 'commodities',
        //   children: [
        //     {
        //       name: '课程中心',
        //       permission: 'commodities.list',
        //       index: '/goods',
        //     },
        //     {
        //       name: '已购课程',
        //       permission: 'commodities.my',
        //       index: '/myClass',
        //     },
        //   ],
        // },
        {
          name: '课程中心',
          icon: 'el-icon-s-goods',
          permission: 'course_center',
          children: [
            {
              name: '我的课程',
              index: '/packageList',
              permission: 'course_center.my_course',
            },
          ],
        },
        {
          name: '上课统计',
          icon: 'el-icon-data-line',
          permission: 'school_statistics',
          children: [
            {
              name: '上课统计',
              permission: 'school_statistics_consume',
              index: '/statistical',
            },
            // {
            //   name: '上课日志',
            //   permission: 'school_statistics_log',
            //   index: '/classlog',
            // },
          ],
        },
        // {
        //   name: '课件管理',
        //   icon: 'el-icon-folder-opened',
        //   permission: 'school_course',
        //   children: [
        //     {
        //       name: '云盘资源管理',
        //       permission: 'school_course_cloud',
        //       index: '/courseware',
        //     },
        //     {
        //       name: '互动课件管理',
        //       permission: 'system.classroom',
        //       index: '/coursewareai',
        //     }
        //   ],
        // },
        {
          name: '课件后台',
          hide: this.$store.state.from === 'schoolCenter',
          icon: 'el-icon-menu',
          permission: 'school_courseAdmin',
          noChildren: true,
          index: 'courseAdmin',
          children: [],
        },
        {
          name: '老师管理',
          icon: 'el-icon-user-solid',
          permission: 'school_teacher',
          children: [
            {
              name: '老师管理',
              permission: 'school_teacher_list',
              index: '/teacher',
            },
          ],
        },
        {
          name: '班级管理',
          icon: 'el-icon-s-management',
          permission: 'school_classes',
          children: [
            {
              name: '班级管理',
              permission: 'school_classes_list',
              index: '/classmanage',
            },
          ],
        },
        {
          name: '学生管理',
          icon: 'el-icon-s-opportunity',
          permission: 'school_student',
          children: [
            {
              name: '学生管理',
              permission: 'school_student_list',
              index: '/student',
            },
          ],
        },
        {
          name: '课程分销数据',
          noChildren: true,
          icon: 'el-icon-s-finance',
          permission: 'commodities.distribution',
          index: '/courseDistribution',
          children: [],
        },
      ];
      const agent = [{
        name: '代理商中心',
        icon: 'el-icon-s-unfold',
        permission: 'school_factor',
        children: [
          {
            name: '代理校区',
            permission: 'school_factor_campus',
            index: '/factorCampus',
          },
        ],
      }];
      this.menus = this.isAgent && this.isAgent.status === 1 ? [...menus, ...agent] : menus;
    },
    /**
     * @param {String} index 菜单项的唯一标识，同时也是点击该菜单项所进入的页面路由
     */
    onSelectMenu(index) {
      if (index === 'courseAdmin') {
        const url = this.$domain.courseware; // 课件后台地址
        // 跳转平台回调课件后台
        window.open(`${baseUrl}/oauth/authorize?
                          client_id=5&
                          redirect_uri=${url}&
                          response_type=token&
                          scope=&state=auto`);
      } else {
        this.$router.push(`${index}?page=1&per_page=10&order[id]=desc`);
      }
    },
    goIndex() {
      this.$router.push('/');
    },
    checkRoleType() {
      return this.user.id === this.school.main_id;
    },
  },
};
</script>

<template>
  <div
    v-if="show"
    class="main-menu">
    <h1
      class="main-menu__title"
      @click="goIndex">校区管理系统</h1>
    <el-menu
      :default-active="defaultActive"
      unique-opened
      @select="onSelectMenu"
    >
      <template v-for="menu in menus">
        <el-submenu
          v-if="!menu.hide && !menu.noChildren && $permissions(menu.permission)"
          :index="menu.permission">
          <template slot="title">
            <i :class="menu.icon"/>
            <span>{{ menu.name }}</span>
          </template>
          <el-menu-item
            v-for="submenu in menu.children"
            v-if="$permissions(submenu.permission)"
            :key="submenu.index"
            :index="submenu.index"
            style="padding-left:55px;"
          >
            <span slot="title">{{ submenu.name }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          v-else-if="!menu.hide && $permissions(menu.permission)"
          :index="menu.index"
          class="no_children">
          <i :class="menu.icon"/>
          <span slot="title">{{ menu.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<style lang="scss">
.main-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 200px;
  text-align: center;
  .main-menu__title {
    padding: 1.2em 0;
    font-size: 16px;
    background: #002140;
    margin: 0;
    color: #fff;
    cursor: pointer;
  }
  .el-menu {
    flex: auto;
    background: #001529;
    border: none;
    text-align: left;
  }
  .el-submenu__title {
    font-size: 14px;
    letter-spacing: 1px;
    color: rgba(255, 255, 255, 0.65);
    i {
      color: rgba(255, 255, 255, 0.65);
    }
    &:hover, &:hover i{
      background: none;
      color: #fff;
    }
  }
  .el-submenu {
    .el-menu-item {
      background: #000c17;
      color: rgba(255, 255, 255, 0.65);
      padding: 0;
      &:focus, &:hover {
        background: #000c17;
        color: #fff;
      }
    }
  }
  .el-menu-item {
    &.is-active {
      color: #fff !important;
      background: var(--color-primary) !important;
    }
    &.no_children {
      color: rgba(255,255,255,0.65);
      &:hover {
        color: rgba(255,255,255, 1);
        background: none;
        i {
          color: #fff;
        }
      }
      /*&.is-active {*/
      /*  color: rgba(255,255,255,0.65) !important;*/
      /*  background: none !important;*/
      /*}*/
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main/Menu.vue